import { ChartFilterConstants } from './ChartFilter.constants';

var initialState = {};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case ChartFilterConstants.GET_PREFERRED_CHART_FILTERS_REQUEST:
      return {
        ...state,
        chartFilters: {
          loading: true,
          error: false
        }
      };

    case ChartFilterConstants.GET_PREFERRED_CHART_FILTERS_SUCCESS:
      return {
        ...state,
        chartFilters: action.payload,
        loading: false,
        error: false
      };

    case ChartFilterConstants.GET_PREFERRED_CHART_FILTERS_FAILED:
      return {
        ...state,
        chartFilters: {
          loading: false,
          error: true
        }
      };

    case ChartFilterConstants.GET_FILTER_UPDATED_CHART_ID:
      return {
        ...state,
        filterUpdatedChartID: action.payload
      };

    default:
      return state;
  }
}
